module.exports = __webpack_public_path__ + "img/CurrencyBtc.61924649.png";